import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import EmployeeCard from '@/platform/common/components/EmployeeCard/EmployeeCard';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import SearchBarFilter from '@/platform/common/components/SearchBarFilter/SearchBarFilter';
import SelectedCustomer from '@/platform/common/components/SelectedCustomer/SelectedCustomer';
import { useFilters } from '@/platform/hooks/useFilters';
import { localDate } from '@/platform/lib/utils';
import {
    Badge,
    Container,
    FilterBarDropdown,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/platform/ui';
import { usePage } from '@inertiajs/react';

const CustomerIndexView = () => {
    const { auth, questionnaires, states } = usePage().props;
    const { filters, updateFilters, isSorted } = useFilters(['questionnaires']);

    return (
        <Container>
            <SelectedCustomer />

            <Segment>
                <SegmentHeader
                    header={`Vragenlijsten (${questionnaires?.meta?.total || 0})`}
                />
                <SegmentContent>
                    <SearchBarFilter only={['questionnaires']}>
                        <FilterBarDropdown
                            multiple
                            selectAll
                            label={`Entiteiten (${filters?.entity_ids?.length || 0}/${auth?.customer?.entities?.length || 0})`}
                            options={auth.customer?.entities?.map(entity => ({
                                id: entity.id,
                                name: entity.name,
                            }))}
                            value={filters?.entity_ids || []}
                            onChange={value =>
                                updateFilters('entity_ids', value)
                            }
                        />
                        <FilterBarDropdown
                            multiple
                            clearable
                            label={`States (${filters?.states?.length || 0}/${states?.length || 0})`}
                            options={states || []}
                            value={filters?.states || []}
                            onChange={value => updateFilters('states', value)}
                        />
                    </SearchBarFilter>

                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>Medewerker</TableHeaderCell>
                                {filters?.entity_ids?.length > 1 && (
                                    <TableHeaderCell>Entiteit</TableHeaderCell>
                                )}
                                <TableHeaderCell
                                    sorted={isSorted('start_date')}
                                    onClick={() =>
                                        updateFilters('sort', 'start_date')
                                    }
                                >
                                    Datum indienst
                                </TableHeaderCell>
                                <TableHeaderCell>
                                    Datum uitdienst
                                </TableHeaderCell>
                                <TableHeaderCell textAlign='center'>
                                    Status
                                </TableHeaderCell>
                                <TableHeaderCell textAlign='right'>
                                    Totaal aantal vragen
                                </TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {questionnaires?.meta?.total === 0 && (
                                <NoDataRow
                                    numberOfColumns={
                                        filters?.entity_ids?.length > 1 ? 6 : 5
                                    }
                                />
                            )}

                            {questionnaires?.data?.map(questionnaire => (
                                <TableRow key={questionnaire.id}>
                                    <TableCell>
                                        <EmployeeCard
                                            link
                                            employee={questionnaire?.employee}
                                        />
                                    </TableCell>
                                    {filters?.entity_ids?.length > 1 && (
                                        <TableCell>
                                            {questionnaire?.entity?.name}
                                        </TableCell>
                                    )}
                                    <TableCell>
                                        {localDate(
                                            questionnaire?.employee
                                                ?.latest_base_employment_group
                                                ?.start_date
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {localDate(
                                            questionnaire?.employee
                                                ?.latest_base_employment_group
                                                ?.end_date
                                        )}
                                    </TableCell>
                                    <TableCell textAlign='center'>
                                        {questionnaire?.completed_at && (
                                            <Tooltip>
                                                <TooltipTrigger>
                                                    <Badge
                                                        color={
                                                            questionnaire.state_color
                                                        }
                                                    >
                                                        {
                                                            questionnaire.state_label
                                                        }
                                                    </Badge>
                                                </TooltipTrigger>
                                                <TooltipContent>
                                                    {localDate(
                                                        questionnaire?.completed_at
                                                    )}
                                                </TooltipContent>
                                            </Tooltip>
                                        )}
                                        {!questionnaire?.completed_at && (
                                            <Badge
                                                color={
                                                    questionnaire.state_color
                                                }
                                            >
                                                {questionnaire.state_label}
                                            </Badge>
                                        )}
                                    </TableCell>
                                    <TableCell textAlign='right'>
                                        {questionnaire.unique_questions_count}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>

                <SegmentFooter>
                    <CustomPagination
                        meta={questionnaires?.meta}
                        only={['questionnaires']}
                    />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default CustomerIndexView;
